const ITEMS = [
    "DATA ANALYTICS",
    "WEBSITE DESIGN",
    "LOGO & BRANDING",
    "AI VIDEO & ADS",
    "SOCIAL MEDIA CREATIVES",
    "DIGITAL MARKETING",
];

function Row({ hidden }) {
    return (
        <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
            {ITEMS.map((item) => (
                <span key={item} className="flex items-center">
                    <span className="px-8 text-sm sm:text-base font-medium tracking-[0.28em] text-cream/90 whitespace-nowrap">
                        {item}
                    </span>
                    <span className="text-gold text-lg" aria-hidden="true">
                        ✦
                    </span>
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <div
            className="relative bg-burgundy py-5 overflow-hidden"
            data-testid="brand-marquee"
        >
            <div className="flex w-max animate-marquee">
                <Row />
                <Row hidden />
            </div>
        </div>
    );
}
